<opac-dialog [open]="open" size="xlarge" (opened)="loadFilter()" (closed)="closeDialog()">
  <div slot="header">
    <div class="header-row">
      <h3 *ngIf="!isLoading() || filter()?.name">{{ filter().label }}</h3>
      <opac-skeleton *ngIf="isLoading() && !filter()?.name" style="width: 200px; height: 18px;"></opac-skeleton>

      <opac-button (click)="closeDialog()" [ariaLabel]="'common.close' | translate" [opacTooltip]="'common.close' | translate">
        <opac-icon slot="only-icon" icon="close"></opac-icon>
      </opac-button>
    </div>

    <div class="header-row">
      <opac-search-bar *ngIf="filter()?.name" (search)="search($event)"></opac-search-bar>
    </div>
  </div>

  <section *ngIf="!isLoadingSearch()">
    <app-filter-list-dialog-button
      *ngFor="let filterValue of filterValues(); trackBy: filterValuesTrackByFn"
      [count]="filterValue.count"
      (click)="closeDialog({ name: filter().name, value: filterValue.value})"
    >
      {{ filterValue.name }}
    </app-filter-list-dialog-button>

    <opac-infinite-scroll *ngIf="filter()?.name" (load)="loadMore()" [disabled]="!hasMore()"></opac-infinite-scroll>
  </section>

  <section *ngIf="isLoading()" class="skeleton-wrapper">
    <opac-skeleton *ngFor="let _ of [].constructor(39)" style="width: 200px; height: 14px;"></opac-skeleton>
  </section>
</opac-dialog>
